import AutomaticAuthorizationLog from ".";

export const automaticAuthorizationLogRoutes = [
  {
    path: "/automaticAuthorizationLog",
    element: <AutomaticAuthorizationLog />,
  },
];
